import type { KeyboardEvent } from 'react';

/**
 * Linha de tabela que abre algo ao clicar também abre pelo TECLADO (Tab até ela, Enter ou
 * Espaço) — o mesmo padrão da Conferência. Espaço não rola a página; Enter/Espaço dentro de um
 * botão ou campo da própria linha não abre a linha junto.
 */
export function linhaClicavel(abrir: () => void) {
  return {
    tabIndex: 0,
    role: 'button' as const,
    onClick: abrir,
    onKeyDown: (e: KeyboardEvent<HTMLElement>) => {
      if (e.target !== e.currentTarget) return;
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      abrir();
    },
  };
}
